import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const AddBlacklistDomain = withSuspense(lazy(() => import('./add-blacklist')));
export default AddBlacklistDomain;
